/* ============================================================
   Le tiroir de panier Talme : les deux gestes que le theme ne sait pas faire.

   1. RETIRER UN LOT ENTIER. `cart-remove-button` du theme appelle
      `updateQuantity(index, 0)` et ne sait donc retirer qu'UNE ligne. Un pack
      arrive au panier en trois ou quatre lignes : le client devrait cliquer
      quatre croix pour defaire ce qu'il a ajoute en un bouton. `/cart/update.js`
      accepte plusieurs lignes d'un coup, adressees par leur cle.

      LES CLES, PAS LES INDEX. `updateQuantity` travaille avec la position de la
      ligne dans le panier ; retirer la ligne 2 renumerote les suivantes, et le
      deuxieme appel viserait alors la mauvaise. Les cles de ligne
      (`item.key`) ne bougent pas, et `/cart/update.js` les accepte comme
      clefs de son objet `updates`.

   2. AJOUTER LE COMPLEMENT en un clic, sans quitter le tiroir.

   DANS LES DEUX CAS on redemande a Shopify les sections deja rendues
   (`sections: [...]`), exactement comme le font le tunnel de la fiche produit
   et le calculateur de pack, puis on passe la reponse a `renderContents`. Sans
   cela il faudrait un second aller-retour et le tiroir afficherait un etat
   perime le temps de le faire.

   POURQUOI CE FICHIER EST LIE HORS DE `<cart-drawer>`
   `cart.js` remplace `.drawer__inner` par affectation de `innerHTML`. Un
   `<script>` insere de cette facon ne s'execute jamais. Le fichier est donc lie
   avant l'element, une seule fois, et les elements personnalises inseres plus
   tard sont promus tout seuls par le navigateur.
   ============================================================ */

(function () {
  'use strict';

  function racine() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  var SECTIONS = ['main-cart-drawer', 'cart-icon-bubble'];

  /* Rejoue ce que fait le tunnel de la fiche produit apres un ajout : on rend
     les sections renvoyees par Shopify, on previent les scripts tiers, et on
     laisse le tiroir ouvert. */
  function rendre(data) {
    var tiroir = document.querySelector('cart-drawer');

    if (tiroir && data && data.sections && typeof tiroir.renderContents === 'function') {
      /* `renderContents` retire `is-empty` de `.drawer__inner` mais pas de
         `cart-drawer` lui-meme : sans cette ligne, un panier vide par le
         retrait d'un lot rouvrirait sur un panneau blanc. */
      tiroir.classList.toggle('is-empty', data.item_count === 0);
      tiroir.renderContents(data);
    } else {
      window.location.href = racine() + 'cart';
      return;
    }

    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: data })); } catch (e) {}
    if (window.jQuery) {
      try { jQuery(document.body).trigger('cart:updated', [data]); } catch (e) {}
    }
  }

  function envoyer(chemin, corps, bouton, libelleEchec) {
    if (bouton) bouton.disabled = true;

    corps.sections = SECTIONS;
    corps.sections_url = window.location.pathname;

    return fetch(racine() + chemin, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(corps),
    })
      .then(function (res) {
        if (!res.ok) throw new Error(chemin + ' a repondu ' + res.status);
        return res.json();
      })
      .then(rendre)
      .catch(function (err) {
        console.error('talme-panier', err);
        if (bouton) bouton.disabled = false;
        var zone = document.getElementById('CartDrawer-CartErrors');
        if (zone) zone.textContent = libelleEchec;
      });
  }

  /* ---------- retirer un lot ---------- */

  if (!customElements.get('talme-lot-retrait')) {
    customElements.define(
      'talme-lot-retrait',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.pose === 'oui') return;
          this.dataset.pose = 'oui';

          this.addEventListener('click', function (ev) {
            var bouton = ev.target.closest('button');
            if (!bouton) return;
            ev.preventDefault();

            var cles = (this.dataset.cles || '').split(',').filter(Boolean);
            if (!cles.length) return;

            var updates = {};
            cles.forEach(function (cle) {
              updates[cle] = 0;
            });

            envoyer('cart/update.js', { updates: updates }, bouton,
              "Impossible de retirer ce lot, reessayez dans un instant.");
          });
        }
      }
    );
  }

  /* ---------- ajouter le complement ---------- */

  if (!customElements.get('talme-ajout-express')) {
    customElements.define(
      'talme-ajout-express',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.pose === 'oui') return;
          this.dataset.pose = 'oui';

          this.addEventListener('click', function (ev) {
            var bouton = ev.target.closest('button');
            if (!bouton) return;
            ev.preventDefault();

            var variante = parseInt(this.dataset.variante || '0', 10);
            if (!variante) return;

            envoyer('cart/add.js',
              { items: [{ id: variante, quantity: 1 }] }, bouton,
              "Impossible d'ajouter ce produit, reessayez dans un instant.");
          });
        }
      }
    );
  }
})();
